import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DateRange } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { IAddArticleRevenue } from '../../../../../models/add-article-revenue.model';
import { IArticleRevenue } from '../../../../../models/article-revenue.model';
import { IArticle } from '../../../../../models/article.model';
import { IArticleRevenueAddDialogLayout } from '../../../../../models/layout/article-revenue-add-dialog-layout.model';
import { ArticleRevenueFacade } from '../../../../../services/facades/external-data/article-revenue-facade';
import { IArticleRevenueState } from '../../../../../services/facades/external-data/article-revenue.state.model';
import { ArticleLayoutService } from '../../../../../services/layout/article-layout.service';
import { stringToMoment } from '../../../../../utils/moment-utils';

@Component({
    templateUrl: './add-revenue-dialog.component.html',
    styleUrls: [ './add-revenue-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddRevenueDialogComponent implements OnInit, AfterViewInit {

    public articleRevenueState$: Observable<IArticleRevenueState>;
    public formGroup: FormGroup;
    public dialogFieldsValid$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public layout: IArticleRevenueAddDialogLayout;

    constructor(
        @Inject(MAT_DIALOG_DATA) public article: IArticle,
        private myMatDialogRef: MatDialogRef<AddRevenueDialogComponent>,
        private myArticleRevenueFacade: ArticleRevenueFacade,
        private myArticleLayoutService: ArticleLayoutService
    ) {
    }

    public ngOnInit(): void {
        this.layout = this.myArticleLayoutService.getArticleRevenueAddDialogLayout();
        this.articleRevenueState$ = this.myArticleRevenueFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((revenue: { costAccountingTypeId: number, validity: DateRange<Moment>, revenueEuro: number }) => {
            this.validateDialogFields(this.transformDialogData(revenue));
        });
    }

    public async onSave(): Promise<void> {
        const addRevenue: IAddArticleRevenue = this.transformDialogData(this.formGroup.value);

        const addedRevenue: IArticleRevenue = await this.myArticleRevenueFacade.addArticleRevenue(this.article.id, addRevenue);
        if (addedRevenue !== null) {
            this.closeDialog(true);
        }
    }

    public closeDialog(refresh: boolean): void {
        this.myMatDialogRef.close(refresh);
    }

    private validateDialogFields(revenue: IAddArticleRevenue): void {
        if (isNullOrUndefined(revenue.costAccountingTypeId)
            || isNullOrUndefined(revenue.revenueCt)
            || isNullOrUndefined(revenue.from)
            || isNullOrUndefined(revenue.to)
            || revenue.from.isAfter(revenue.to)) {
            this.dialogFieldsValid$.next(false);
        } else {
            this.dialogFieldsValid$.next(true);
        }
    }

    private transformDialogData(revenue: { costAccountingTypeId: number, validity: DateRange<moment.Moment>, revenueEuro: number }): IAddArticleRevenue {
        return {
            costAccountingTypeId: revenue.costAccountingTypeId,
            revenueCt: isNullOrUndefined(revenue.revenueEuro)? null: revenue.revenueEuro * 100,
            from: stringToMoment(revenue.validity.start),
            to: stringToMoment(revenue.validity.end),
        };
    }
}
